import { CardTenantMyClass } from "components/Card/CardTenantMyClass";
import { Course } from "components/Card/interfaces";
import { trackEventGA, trackEventGTM } from "lib/amplitude";
import { useHomeStore } from "modules/Home/homeStore";
import Link from "next/link";
import { useState, useEffect } from "react";

interface CardContinueProps {
  onGoingCourses: Course[];
}

const CardContinue: React.FC<CardContinueProps> = ({ onGoingCourses }) => {
  const { setIsNewHide, setHideSlugs } = useHomeStore((state) => ({
    setIsNewHide: state.setIsNewHide,
    setHideSlugs: state.setHideSlugs,
  }));

  const [hideSlug, setHideSlug] = useState<string[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem("hideSlugs");
    if (stored) {
      try {
        setHideSlug(JSON.parse(stored));
      } catch (err) {
        console.error("Failed to parse hideSlugs from localStorage", err);
      }
    }
  }, []);
  
  const handleHide = (slug: string) => {
    setHideSlug((prev) => [...prev, slug]);
  };

  useEffect(() => {
    if (hideSlug.length > 0) {
      localStorage.setItem("hideSlugs", JSON.stringify(hideSlug));
      setHideSlugs(JSON.stringify(hideSlug));
      setIsNewHide(true);
    }
  }, [hideSlug]);

  return (
    <>
      {onGoingCourses.length > 0 &&
        onGoingCourses.map((course, index) => (
          <Link
            href={{
              pathname: "/course/[courseSlug]",
              query: { courseSlug: course.slug },
            }}
            onClick={() => {
              trackEventGTM({
                event: "b2b_homepage_course_a",
                property: {
                  course_name: course?.name,
                  course_slug: course?.slug,
                  institution_name: course?.institution?.name,
                  remaining_time: (course as any)?.is_remaining_duration,
                  course_progress: (
                    (course?.enrollment_progress?.finished /
                      course?.enrollment_progress?.total) *
                    100
                  )
                    .toString()
                    .slice(0, 4),
                  section: 0,
                  category_name: `Continue Your Course`,
                  index,
                },
              });
              trackEventGA({
                event: "b2b_homepage_course_a",
                property: {
                  course_name: course?.name,
                  course_slug: course?.slug,
                  institution_name: course?.institution?.name,
                  remaining_time: (course as any)?.is_remaining_duration,
                  course_progress: (
                    (course?.enrollment_progress?.finished /
                      course?.enrollment_progress?.total) *
                    100
                  )
                    .toString()
                    .slice(0, 4),
                  section: 0,
                  category_name: `Continue Your Course`,
                  index,
                },
              });
            }}
          >
            <CardTenantMyClass {...course} height={132} isHomePage onHide={handleHide} />
          </Link>
        ))}
    </>
  );
};

export default CardContinue;
